module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a1-12-e512712efc8af90efe09a4910dcb2eae.jpg";